import React from "react";
import "./Alert.css";

export default function Alert(props) {
  return (
    <div
      className={`alertMessage centeredFlex ${
        props.showAlert ? "showAlert" : ""
      }`}
      style={props.bottom ? { bottom: props.bottom } : { bottom: "5rem" }}
    >
      <h2>{props.alertText}</h2>
    </div>
  );
}